import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import HeaderBack from "@/components/dashboard/Header/HeaderBack";

import MotionText from '@/components/common/Motion/MotionText';
import ButtonLink from "@/components/common/Button/ButtonLink";
import MotionImage from '@/components/common/Motion/MotionImage';
import { usePageSetup } from '@/hooks/usePageSetup';

import CommissionHowImage from '@/assets/visuals/bolt/commission-how.png';
import CommissionHow2Image from '@/assets/visuals/bolt/commission-how-2.png';
import CommissionHowExampleImage from '@/assets/visuals/bolt/commission-how-example.png';

export const BoltCommissionHowPage = () => {
  const { t } = useTranslation()
  usePageSetup(t('bolt.pageTitle.commissionHow'))
  return (
    <div className="h-full bg-white flex flex-col">
      <HeaderBack />
      <div className="flex flex-col px-5 pb-[10rem]">
        <MotionText
          as='h1'
          className='font-semibold text-3xl mb-2'>
            {t('bolt.commissionHow.title')}
        </MotionText>
        <MotionText
          as='p'
          className='text-xs text-zinc-700'
        >
          {t('bolt.commissionHow.subtitle')}
        </MotionText>
        <MotionImage
          src={CommissionHowExampleImage}
          alt='Bolt Commission How'
          className='mt-4 mb-4 object-contain'
        />
        <MotionText
          as='p'
          className='text-base text-zinc-700 mt-2'
        >
          {t('bolt.commissionHow.step1')}
        </MotionText>
        <MotionImage
          src={CommissionHowImage}
          alt='Bolt Commission How'
          className='mt-4 mb-2 object-contain'
        />
        <MotionText
          as='p'
          className='text-base text-zinc-700 mt-2'
        >
          {t('bolt.commissionHow.step2')}
        </MotionText>
        <MotionImage
          src={CommissionHow2Image}
          alt='Bolt Commission How 2'
          className='mt-4 mb-2 object-contain'
        />
        <motion.div
          className="absolute bottom-0 -ml-5 px-5 pb-4 pt-8 w-full bg-linear-to-t from-white via-white to-transparent from-0% via-40% to-100%"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut"
          }}
        >
          <ButtonLink
            target='_blank'
            to={'https://partners.bolt.eu/invoices'}
            variant='primary'
            className='mb-4 w-full h-[3rem]'
          >
            {t('bolt.commissionHow.goToPortal')}
          </ButtonLink>
          <ButtonLink
            to={'/bolt/commission'}
            variant='secondary'
            className='mb-4 w-full h-[3rem]'
          >
            {t('common.goBack')}
          </ButtonLink>
        </motion.div>
      </div>
    </div>
  );
};

export default BoltCommissionHowPage;
